export default __webpack_public_path__ + "static/Ray-ban-sunglass-case-hack-56c6e3b52000104c9fb3bde5dce81383.jpg";